import { render, staticRenderFns } from "./Consent.vue?vue&type=template&id=64612bc5"
import script from "./Consent.vue?vue&type=script&lang=js"
export * from "./Consent.vue?vue&type=script&lang=js"
import style0 from "./Consent.vue?vue&type=style&index=0&id=64612bc5&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64612bc5')) {
      api.createRecord('64612bc5', component.options)
    } else {
      api.reload('64612bc5', component.options)
    }
    module.hot.accept("./Consent.vue?vue&type=template&id=64612bc5", function () {
      api.rerender('64612bc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/InventionApply/Consent.vue"
export default component.exports